import { render, staticRenderFns } from "./AdobeLightroomIcon.vue?vue&type=template&id=84f9c4c2"
import script from "./AdobeLightroomIcon.vue?vue&type=script&lang=js"
export * from "./AdobeLightroomIcon.vue?vue&type=script&lang=js"
import style0 from "./AdobeLightroomIcon.vue?vue&type=style&index=0&id=84f9c4c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports